import axios from 'axios';

const BASE_URL = 'https://payrendr-backend.onrender.com/v1';

// Create a reusable Axios instance with improved configuration
const api = axios.create({
    baseURL: BASE_URL,
    // timeout: 20000, // 10 second timeout
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor for request logging (only in development)
if (process.env.NODE_ENV === 'development') {
    api.interceptors.request.use(config => {
        console.log(`[API] ${config.method.toUpperCase()} ${config.url}`, config.data);
        return config;
    });
}

// Interceptor for error handling
api.interceptors.response.use(
    response => response,
    error => {
        // Log the error message if needed
        console.error('API Error:', error.response?.data?.message || error.message || 'An unexpected error occurred');
        return Promise.reject(error); // Reject the whole error object
    }
);
  

export const apiService = {
    get: async (url, token = null, params = {}) => {
        const config = { 
            params,
            headers: token ? { Authorization: `Bearer ${token}` } : {} 
        };
        return api.get(url, config);
    },
    post: async (url, token = null, data) => {
        const config = {
            headers: token ? { Authorization: `Bearer ${token}` } : {}
        };
        return api.post(url, data, config);
    },
    put: async (url, token = null, data) => {
        const config = {
            headers: token ? { Authorization: `Bearer ${token}` } : {}
        };
        return api.put(url, data, config);
    },
    delete: async (url, token = null) => {
        const config = {
            headers: token ? { Authorization: `Bearer ${token}` } : {}
        };
        return api.delete(url, config);
    },
};